module.exports = {
  zh: {
    form: {
      Id: '用户名',
      Name: '姓名',
      Action: '动作',
      Time: '动作时间',
      Group: '角色',
      Menu: '菜单',
      Terminal: '使用终端',
      Search: '搜索',
      Reset: '重置',
    },
    table: {
      No: '序号',
      Id: '用户名',
      Name: '姓名',
      Menu: '菜单',
      Group: "角色",
      Action: "动作",
      Content: "动作内容",
      Time: "动作时间",
      Device: "平台",
      Terminal: "终端",
      DeviceNo: "设备号/ip"
    }
  },
  en: {
    form: {
      Id: 'Id',
      Name: 'Name',
      Action: 'Action',
      Time: 'Time',
      Group: 'Group',
      Menu: 'Menu',
      Terminal: 'Terminal',
      Search: 'Search',
      Reset: 'Reset',
    },
    table: {
      No: 'No',
      Id: 'Id',
      Name: "Name",
      Group: "Group",
      Menu: 'Menu',
      Action: "Action",
      Content: "Content",
      Time: "Time",
      Device: "Device",
      Terminal: "Terminal",
      DeviceNo: "设备号/ip"
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/logPage.js